export default __webpack_public_path__ + "static/media/770.b94009cd.gif";